import React, { useEffect } from 'react';
import { StyledBodyContainer } from './routes.style';
import { useAppRouter } from '@makemydeal/dr-sales-checkin-ui-utils';

export const BodyContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ children }) => {
    const { location } = useAppRouter();
    useEffect(() => {
        // NOTE: upon navigating to a new location; scroll to the top. Moved here from `Card`.
        window.scroll({
            top: 0,
            left: 0
        });
    }, [location]);

    return <StyledBodyContainer data-testid="sales-checkin-body-container">{children}</StyledBodyContainer>;
};
